import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=73434cb3&"
import script from "./Configuration.vue?vue&type=script&lang=js&"
export * from "./Configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73434cb3')) {
      api.createRecord('73434cb3', component.options)
    } else {
      api.reload('73434cb3', component.options)
    }
    module.hot.accept("./Configuration.vue?vue&type=template&id=73434cb3&", function () {
      api.rerender('73434cb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/Configuration.vue"
export default component.exports